// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // base_url : 'https://api-testing.vendorportalidex.in/api/',
  // base_url : 'https://api.vendorportalidex.in/api/',
  base_url: 'https://idexvendorprodbackend.azurewebsites.net/api/',
  // base_url: 'https://idexvendorportaldevbackend.azurewebsites.net/api/',
  // base_url: 'http://[IP_ADDRESS]/api/',
  // base_url: 'http://192.168.0.118:90/api/',
  production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.